<template>
  <div id="app">
    <Header :lang="lang" @change-lang="changeLang"/>
    <div class="page">
      <section class="content">
        <div class="bg_content"></div>
        <div id="content">
          <router-view :lang="lang" :title="getTitle"/>
        </div>
      </section>
    </div>
  <Footer :lang="lang"/>
  </div>
</template>
<script>
  import Header from "./components/Header";
  import Footer from "./components/Footer";
  export default {
    components: {Footer, Header},
    data() {
      return {
        lang: 'ru',
        DEFAULT_TITLE: ' | Разработка Web проектов | Егор Котов'
      }
    },
    mounted() {
      if(!localStorage.lang) {
        localStorage.lang = 'ru'
      }
      this.lang = localStorage.lang
    },
    computed: {
      getTitle() {
        return this.$route.meta.title ? this.$route.meta.title[this.lang] : ''
      }
    },
    methods: {
      changeLang() {
        localStorage.lang = this.lang === 'ru' ? 'en' : 'ru'
        this.lang = localStorage.lang
        document.title = this.$route.meta.title[this.lang] + this.DEFAULT_TITLE
      }
    },
   }
</script>
<style>
  body, html{
    margin: 0;
    padding: 0;
  }
  @font-face {
    font-family: Sochi2014Bold;
    src: url('assets/fonts/Sochi2014_Bold.ttf');
  }
  @font-face {
    font-family: Sochi2014Medium;
    src: url('assets/fonts/Sochi2014_Medium.ttf');
  }
  @font-face {
    font-family: Sochi2014Light;
    src: url('assets/fonts/Sochi2014_Light.ttf');
  }

  body{
    font-family: Arial, Helvetica, sans-serif;
    background: #657b83;
    font-size: 14px;
  }
  .page{
    background: #FDF6E3;
  }
  .ct_wrapper{
    position: relative;
    padding: 25px;
  }
  p{
    color: #002b36;
    font-size: 14px;
    font-family: Arial, Helvetica, sans-serif;
  }
  p.fl:first-letter{
    font-size: 20px;
    font-weight: bold;
  }
  .icons{
    position: absolute;
  }

  .django_ico{
    width: 200px;
    height: 200px;
    top: 350px;
    left: 100px;
  }
  .python_ico{
    width: 200px;
    top: 500px;
    left: 200px;
  }
  .mysql_ico{
    width: 130px;
    top: 340px;
    left: 300px;
  }
  .postgresql_ico{
    width: 130px;
    top: 480px;
    left: 420px;
  }
  .HTML5_ico{
    width: 130px;
    top: 340px;
    left: 500px;
  }
  .css3_ico{
    width: 100px;
    top: 340px;
    left: 680px;
  }
  .php_ico{
    width: 130px;
    top: 500px;
    left: 740px;
  }
  .angular_ico{
    width: 130px;
    top: 480px;
    left: 580px;
  }
  .vue_ico{
    width: 130px;
    top: 500px;
    left: 40px;
  }

  header, footer, section.content{
    width: 940px;
    margin: 0 auto;
    position: relative;
  }
  .header_wrapper{
    background: #003340 url("assets/img/header_bg.jpg") center top no-repeat;
    height: 190px;
  }
  header .logo{
    font-family: Sochi2014Light, Helvetica, Arial, sans-serif;
    font-size: 60px;
    color: #859900;
    text-decoration: none;
    position: absolute;
    display: block;
    left: 30px;
    top: 10px;
  }
  header .ek{
    font-family: Sochi2014Light, Helvetica, Arial, sans-serif;
    font-size: 36px;
    color: #b58900;
    position: absolute;
    display: block;
    left: 250px;
    top: 70px;
  }
  .lang_button_wrapper{
    position: absolute;
    right: 25px;
    top: 25px;
    width: 80px;
    height: 25px;
  }
  .lang_button {
    display:block;
    width:26px;
    height:26px;
    line-height:26px;
    border: 1px solid #002b36;
    border-radius: 50%;
    color:#f5f5f5;
    text-align:center;
    text-decoration:none;
    background: #073642;
    font-size:12px;
    font-weight:bold;
    float: left;
    cursor: pointer;
  }
  .lang_button:hover,
  .lang_button.active{
    background: #b58900;
    color: #073642;
  }

  .social_wrapper{
    position: absolute;
    width: 141px;
    height: 33px;
    top: 130px;
    left: 757px;
    z-index: 2;
  }
  .social_wrapper a{
    background: url("assets/img/social_icons.png") no-repeat;
    float: left;
    height: 33px;
    width: 33px;
    text-decoration: none;
  }
  .social_wrapper a.google{background-position: 0, 0;}
  .social_wrapper a.vk{background-position: -34px, 0;}
  .social_wrapper a.mail{background-position: -68px, 0;}
  .social_wrapper a.facebook{background-position: -102px, 0;}
  .social_wrapper a.google:hover{background-position: -141px, 0;}
  .social_wrapper a.vk:hover{background-position: -175px, 0;}
  .social_wrapper a.mail:hover{background-position: -209px, 0;}
  .social_wrapper a.facebook:hover{background-position: -243px, 0;}

  .text-center{text-align: center;}
  .text-right{text-align: right;}

  img{
    width: 400px;
  }

  h1{
    font-family: Arial, Helvetica, sans-serif;
    color: #B58900;
  }
  section.content{
    min-height: 660px;
    position: relative;
  }
  .bg_content{
    position: absolute;
    background: url("assets/img/bg_content.jpg");
    width: 240px;
    height: 112px;
    top: 0;
    left: -150px;
  }
  #content{
    position: absolute;
    width: 940px;
    height: 687px;
    left: 0;
    top: -16px;
    background: #eee8d5;
  }
  #content a{
    text-decoration: none;
    font-size: 14px;
    color: #002b36;
  }
  #content .links{
    padding-top: 56px;
  }
  #content .links img{
    margin-right: 10px;
  }
  #content a:hover,
  #content .links span:hover
  {
    text-shadow: 2px 2px 6px rgba(50, 50, 50, 1);
  }

  .page_header{
    background: url("assets/img/page_header_bg.png") no-repeat center 2px;
    width: 940px;
    height: 38px;
    text-align: center;
    text-transform: uppercase;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 38px;
    font-size: 30px;
    color: #fcf5e2;
    text-shadow: 2px 2px 6px rgba(50, 50, 50, 1);
  }

  .me{
    width: 270px;
    height: 320px;
    float: left;
    margin: 0 20px 20px 0;
  }
  dt{
    font-weight: bold;
  }
  dd{
    margin-left: 20px;
  }

  .col{
    float: left;
    width: 50%;

  }
  .contact_form{
    margin: 60px 0 0 120px;
    width: 280px;
  }

  .contact_form label{
    display: inline-block;
    width: 80px;
  }
  .contact_form input[type=text]{
    width: 190px;
    border: 2px solid #002b36;
  }
  .contact_form textarea{
    width: 270px;
    height: 120px;
    border: 2px solid #002b36;
  }

  .mailicon, .skype, .vk, .geo{width: 30px;}

  .clearfix:before,
  .clearfix:after{
    content: '.';
    display: block;
    overflow: hidden;
    visibility: hidden;
    font-size: 0;
    line-height: 0;
    width: 0;
    height: 0;
  }

  .clearfix:after {
    clear: both;
  }
  .clearfix{
    zoom: 1;
  }
</style>
